export const eventListeners = {
    addBookmark: 'JQ_REACT_ADD_BOOKMARK',
    deleteBookmark: 'JQ_REACT_DELETE_BOOKMARK'
}

export const connectEventToState = {
    create: (eventListenerName: string, element: HTMLElement, callback: EventListenerOrEventListenerObject): Event => {
        if (eventListenerName && element) {
            // should cover most old browsers
            let event = document.createEvent('Event');
            event.initEvent(eventListenerName, true, true);
            element.addEventListener(eventListenerName, callback, false);
            return event;
        }
    }
} 